const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['note', [this, 'block_note']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`datetime`] = (((context.has(`datetime`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`datetime`) ? context.get(`datetime`) : null), `now`])) : (`now`));
                context.proxy[`days`] = (((context.has(`days`))) ? (this.env.getFilter('default').traceableCallable(2, this.source)(...[(context.has(`days`) ? context.get(`days`) : null), 1])) : (1));
                this.startOutputBuffer();
                this.traceableDisplayBlock(3, this.source)('note', context.clone(), blocks);
                context.proxy[`_note`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<time class="c-calendar-date c-calendar-date--`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, this.env.getFilter('lower').traceableCallable(5, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(5, this.source)(...[this.env, (context.has(`datetime`) ? context.get(`datetime`) : null), `F`])]), `html`, null, true]));
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"
  datetime="`);
                this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(6, this.source)(...[this.env, (context.has(`datetime`) ? context.get(`datetime`) : null), `Y-m-d`]), `html`, null, true]));
                this.echo(`"
>
  <span class="c-calendar-date__header">
    `);
                this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(9, this.source)(...[this.env, (context.has(`datetime`) ? context.get(`datetime`) : null), `M`]), `html`, null, true]));
                this.echo(`
  </span>
  <span class="c-calendar-date__main">
    <span class="c-calendar-date__day">
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(13, this.source)(...[this.env, (context.has(`datetime`) ? context.get(`datetime`) : null), `j`]), `html`, null, true]));
                this.echo(`
    </span>
    `);
                if ((context.has(`_note`) ? context.get(`_note`) : null)) {
                    this.echo(`      <span class="c-calendar-date__note">
        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`_note`) ? context.get(`_note`) : null), `html`, null, true]));
                    this.echo(`
      </span>
    `);
                }
                this.echo(`  </span>
</time>
`);
            }

            block_note(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`note`) ? context.get(`note`) : null), `html`, null, true]));
            }

            getTemplateName() {
                return `876f477a1b9508f96163a9eab2fb4bcbf1cca1395e1e75daf69f79f6308e2039`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `876f477a1b9508f96163a9eab2fb4bcbf1cca1395e1e75daf69f79f6308e2039`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '876f477a1b9508f96163a9eab2fb4bcbf1cca1395e1e75daf69f79f6308e2039');

let template = env.loadTemplate('876f477a1b9508f96163a9eab2fb4bcbf1cca1395e1e75daf69f79f6308e2039');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/calendar-date/calendar-date.twig", args: context }
     );
     return rendered;;
};